var React = require('react');

function ThumbsUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M198 448h172c15.7 0 28.6-9.6 34.2-23.4l57.1-135.4c1.7-4.4 2.6-9 2.6-14v-38.6c0-21.1-17-44.6-37.8-44.6H306.9l18-81.5.6-6c0-7.9-3.2-15.1-8.3-20.3L297 64 171 191.3c-6.8 6.9-11 16.5-11 27.1v192c0 21.1 17.2 37.6 38 37.6zM48 224h64v224H48z"}));
}

ThumbsUpInline.defaultProps = {"stroke":"currentColor","fill":"currentColor","strokeWidth":"0","viewBox":"0 0 512 512","height":"1em","width":"1em"};

module.exports = ThumbsUpInline;

ThumbsUpInline.default = ThumbsUpInline;
